const FEATURES = [
  { icon: '⚡', title: 'Create in 30 Seconds',   desc: "Set date, time, location. Share one link. Everyone confirms. No more '47 messages later, still no game.'" },
  { icon: '📍', title: 'Games Near You',          desc: 'See what\'s happening in your area. Friends of friends, not strangers. Expand your network naturally.' },
  { icon: '🏆', title: 'Challenge Friends',       desc: 'Head-to-head records. Track who\'s better. Build your football story with stats that actually matter.' },
  { icon: '👤', title: 'Football Profile',        desc: 'Position, stats, media highlights. Upload your best moments. Your complete digital football identity.' },
  { icon: '🛡️', title: 'Quality Control',        desc: 'See player profiles before they join. Build reputation through challenges. Your squad, your standards.' },
  { icon: '🆓', title: 'Free. Forever.',          desc: 'No pitch markup. No subscriptions. No hidden costs. Access to football shouldn\'t have a price tag.' },
];

export default function FeaturesSection() {
  return (
    <section style={{ padding: '7rem clamp(1rem,4vw,3rem)', position: 'relative', overflow: 'hidden' }}>
      {/* Top accent line */}
      <div style={{
        position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)',
        width: '60%', height: 1,
        background: 'linear-gradient(90deg,transparent,rgba(232,96,74,0.3),transparent)',
      }} />

      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        {/* Heading */}
        <div className="vis" style={{ marginBottom: '4rem' }}>
          <span className="section-tag">WHAT WE OFFER</span>
          <h2 className="section-title" style={{ fontSize: 'clamp(40px,5vw,62px)' }}>
            Your Squad,<br /><span>Better Organized.</span>
          </h2>
        </div>

        {/* Grid */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 2, background: 'rgba(232,96,74,0.08)' }}>
          {FEATURES.map((f, i) => (
            <div key={i} className="vis card-hover" style={{
              background: 'var(--navy)', padding: '2.5rem',
              position: 'relative', overflow: 'hidden',
            }}>
              {/* Top hover line */}
              <div style={{
                position: 'absolute', top: 0, left: 0, right: 0, height: 2,
                background: 'linear-gradient(90deg,transparent,var(--coral),transparent)',
                transform: 'scaleX(0)', transformOrigin: 'left',
                transition: 'transform 0.4s',
              }} />
              <div style={{ fontSize: 32, marginBottom: '1rem' }}>{f.icon}</div>
              <h3 style={{
                fontFamily: 'var(--font-d)', fontSize: 20, fontWeight: 800,
                textTransform: 'uppercase', letterSpacing: 1, marginBottom: '0.75rem',
              }}>{f.title}</h3>
              <p style={{ color: 'var(--muted)', fontSize: 15, lineHeight: 1.75 }}>{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
